import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentHeader } from '../../components/SectionContentHeader'

export const SectionContentInstanceMissionHero: React.FunctionComponent =
  () => (
    <Section
      prerender
      padding={200}
      backgroundColor="black"
      cloudinaryBackground={{
        publicId: 'photography/mission-home-banner',
        alt: 'Qwick hospitality professionals at work',
      }}
    >
      <SectionContentHeader
        id="mission-hero"
        align="center"
        subheading="MISSION + VALUES"
        heading="We believe hospitality is powered by people."
        description={null}
        links={null}
        showAppStoreLinks={false}
        eyebrowColor={(t) => t.palette.primary.main}
      />
    </Section>
  )
